import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'

import LoadingParent from 'components/LoadingParent'
import NavigationHelper from 'layers/navigation/navigationHelper'
import SubNavGetter, {
  SubNavGetterComponentPropTypes,
} from 'layers/content/v2/Hocs/SubNavGetter'
import {
  shouldUseCurriculumNavigation,
  useCurriculumNavigation,
} from 'layers/content/v3/hooks/useCurriculumNavigation'
import {
  getThemeFromUrl,
  getProductFromUrl,
  resolveRouteServiceApp,
} from 'utils/routing/routeHelpers'
import { selectors as licenseSelectors } from 'store/licenseManager'

import Component from './component'

const resolveNavigationApp = () => {
  try {
    return resolveRouteServiceApp(window.location.pathname)
  } catch {
    return null
  }
}

function NavigationContainer(props) {
  const theme = getThemeFromUrl()
  const productConfig = getProductFromUrl()
  const app = resolveNavigationApp()
  const {
    data: curriculumNavigation,
    loading: isCurriculumNavigationLoading,
  } = useCurriculumNavigation({
    app,
    enabled: shouldUseCurriculumNavigation(app),
  })

  return (
    <React.Fragment>
      {isCurriculumNavigationLoading && (
        <LoadingParent loadingText="Loading..." />
      )}
      <Component
        curriculumNavigation={curriculumNavigation}
        product={productConfig}
        theme={theme}
        {...props}
      />
    </React.Fragment>
  )
}

const navigationConnect = connect(
  NavigationHelper.mapStateToProps,
  NavigationHelper.mapDispatchToProps,
)

const userConnect = connect(state => {
  const { userAccessManager } = state || {}
  const { claims } = userAccessManager || {}
  const { userProfileManager } = state || {}
  const { profile } = userProfileManager || {}
  const { firstName = '', lastName = '', roles = [] } = profile || {}
  const hasStandaloneDwbAccess =
    licenseSelectors.selectActiveAdminStandaloneDwbSites(state).length > 0

  return {
    roles,
    userClaims: claims,
    name: `${firstName} ${lastName}`.trim(),
    hasStandaloneDwbAccess,
  }
})

NavigationContainer.propTypes = {
  subNavData: SubNavGetterComponentPropTypes,
}

// route-service is skipped (null app) when the curriculum service owns the subnav
const subNavGetterOptions = {
  app: () => {
    const app = resolveRouteServiceApp(window.location.pathname)
    return shouldUseCurriculumNavigation(app) ? null : app
  },
}

export default compose(
  navigationConnect,
  userConnect,
)(SubNavGetter(NavigationContainer, subNavGetterOptions))
